export default {
    api: 'https://monkfish-app-pp93f.ondigitalocean.app'
    // api: 'http://localhost:8000'
}


// WEBPACK FOOTER //
// ./src/config/index.js